<div id="editStrike">
    <hr />
    <div class="row" data-testid="strike-edit-page">
        <div class="col-xs-12 personal-info">
            <div class="alert alert-info alert-dismissable">
                <i class="fa fa-plus"></i>
                Edit strike. Make sure you fill all required fields.
            </div>
            <form class="form-horizontal" role="form" name="editStrikeForm" [formGroup]="strikeEditForm"
                data-testid="strike-edit-form">
                <div class="form-group">
                    <div class="row">
                        <div class="col-xs-6 col-sm-4">
                            <label  for="title" class="control-label">Title</label>
                            <input
                                class="form-control"
                                name="title"
                                id="title"
                                formControlName="title"
                                type="text"
                                validate-on="blur"
                                required required-message="'Strike title is required'"
                                data-testid="editstrike-form-title" />
                            <div *ngIf="title?.invalid && (title?.dirty || title?.touched)" class="alert alert-danger">
                                <div *ngIf="title?.errors?.['required']" data-testid="title-error">
                                    Title is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-6 col-sm-4">
                            <label for="startDate" class="control-label">Start Date</label>
                            <p class="input-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    name="startDate"
                                    id="startDate"
                                    formControlName="startDate"
                                    validate-on="blur"
                                    required
                                    bsDatepicker
                                    [bsConfig]="{ containerClass: 'theme-red', dateInputFormat: 'YYYY-MM-DD' }"
                                    #dp="bsDatepicker"
                                    data-testid="editstrike-form-startdate" />
                                <span class="input-group-btn">
                                    <button type="button" class="btn btn-default" (click)="dp.show()"
                                        [attr.aria-expanded]="dp.isOpen">
                                        <i class="glyphicon glyphicon-calendar"></i>
                                    </button>
                                </span>
                            </p>
                            <div *ngIf="
                  startDate?.invalid && (startDate?.dirty || startDate?.touched)
                " class="alert alert-danger">
                                <div *ngIf="startDate?.errors?.['required']">
                                    Start Date is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-6 col-sm-4">
                            <label for="endDate" class="control-label">End Date</label>
                            <p class="input-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    name="endDate"
                                    id="endDate"
                                    formControlName="endDate"
                                    validate-on="blur"
                                    bsDatepicker
                                    [bsConfig]="{ containerClass: 'theme-red', dateInputFormat: 'YYYY-MM-DD' }"
                                    #dp2="bsDatepicker"
                                    data-testid="editstrike-form-enddate" />
                                <span class="input-group-btn">
                                    <button type="button" class="btn btn-default" (click)="dp2.show()">
                                        <i class="glyphicon glyphicon-calendar"></i>
                                    </button>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="form-group form-group-sm">
                    <div class="row">
                        <div class="col-xs-6 col-sm-4">
                            <div class="col-xs-12 col-sm-6 pull-left">
                                <label for="minThresholdHours" class="control-label">Min Threshold(in Hours)</label>
                                <input
                                    class="form-control text-center"
                                    type="text"
                                    name="minThresholdHours"
                                    id="minThresholdHours"
                                    formControlName="minThresholdHours"
                                    validate-on="blur"
                                    required
                                    data-testid="editstrike-form-minthresholdhours" />
                                <div *ngIf="
                    minThresholdHours?.invalid &&
                    (minThresholdHours?.dirty || minThresholdHours?.touched)
                  " class="alert alert-danger">
                                    <div *ngIf="minThresholdHours?.errors?.['required']">
                                        Minimum Threshold is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 pull-right">
                                <label for="minThresholdDays" class="control-label">Min Threshold(Days)</label>
                                <input
                                    class="form-control text-center"
                                    type="text"
                                    name="minThresholdDays"
                                    id="minThresholdDays"
                                    formControlName="minThresholdDays"
                                    validate-on="blur"
                                    required
                                    data-testid="editstrike-form-minthresholddays" />
                                <div *ngIf="
                    minThresholdDays?.invalid &&
                    (minThresholdDays?.dirty || minThresholdDays?.touched)
                  " class="alert alert-danger">
                                    <div *ngIf="minThresholdDays?.errors?.['required']">
                                        Minimum Threshold is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-6 col-sm-4">
                            <label for="participationBenefitAmt" class="control-label">Participation Benefit Amount (Min)</label>
                            <div class="input-group">
                                <div class="input-group-addon">$</div>
                                <input
                                    class="form-control"
                                    type="text"
                                    name="participationBenefitAmt"
                                    id="participationBenefitAmt"
                                    formControlName="participationBenefitAmt"
                                    validate-on="blur"
                                    required
                                    data-testid="editstrike-form-participationbnftamt" />
                                <div class="input-group-addon">.00</div>
                            </div>
                            <div *ngIf="
                  participationBenefitAmt?.invalid &&
                  (participationBenefitAmt?.dirty ||
                    participationBenefitAmt?.touched)
                " class="alert alert-danger">
                                <div *ngIf="participationBenefitAmt?.errors?.['required']">
                                    Participation Benefit Amount is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-6 col-sm-4">
                            <label for="helperBenefitAmt" class="control-label">Helper Benefit Amount (Max)</label>
                            <div class="input-group">
                                <div class="input-group-addon">$</div>
                                <input
                                    class="form-control"
                                    type="text"
                                    name="helperBenefitAmt"
                                    id="helperBenefitAmt"
                                    formControlName="helperBenefitAmt"
                                    validate-on="blur"
                                    required
                                    data-testid="editstrike-form-helperbnftamt" />
                                <div class="input-group-addon">.00</div>
                            </div>
                            <div *ngIf="
                  helperBenefitAmt?.invalid &&
                  (helperBenefitAmt?.dirty || helperBenefitAmt?.touched)
                " class="alert alert-danger">
                                <div *ngIf="helperBenefitAmt?.errors?.['required']">
                                    Helper Benefit Amount is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <div class="col-xs-6 col-sm-4">
                            <div class="col-xs-12 col-sm-6 pull-left">
                                <label for="lastWeekminThresholdHours" class="control-label">Last Week Min Threshold(in Hours)</label>
                                <input
                                    class="form-control text-center"
                                    type="text"
                                    name="lastWeekminThresholdHours"
                                    id="lastWeekminThresholdHours"
                                    formControlName="lastWeekMinThresholdHours"
                                    validate-on="blur"
                                    required
                                    data-testid="editstrike-form-lastweekminthresholdhours" />
                                <div *ngIf="
                    lastWeekMinThresholdHours?.invalid &&
                    (lastWeekMinThresholdHours?.dirty ||
                      lastWeekMinThresholdHours?.touched)
                  " class="alert alert-danger">
                                    <div *ngIf="lastWeekMinThresholdHours?.errors?.['required']">
                                        Last Week Minimum Threshold is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 pull-right">
                                <label for="lastWeekminThresholdDays" class="control-label">Last Week Min Threshold(Days)</label>
                                <input
                                    class="form-control text-center"
                                    type="text"
                                    name="lastWeekminThresholdDays"
                                    id="lastWeekminThresholdDays"
                                    formControlName="lastWeekMinThresholdDays"
                                    validate-on="blur"
                                    required
                                    data-testid="editstrike-form-lastweekminthresholddays" />
                                <div *ngIf="
                    lastWeekMinThresholdDays?.invalid &&
                    (lastWeekMinThresholdDays?.dirty ||
                      lastWeekMinThresholdDays?.touched)
                  " class="alert alert-danger">
                                    <div *ngIf="lastWeekMinThresholdDays?.errors?.['required']">
                                        Last Week Minimum Threshold is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-6 col-sm-4">
                            <label for="lastWeekParticipationBenefitAmt" class="control-label">Last Week Participation Benefit Amount</label>
                            <div class="input-group">
                                <div class="input-group-addon">$</div>
                                <input
                                    class="form-control"
                                    type="text"
                                    name="lastWeekParticipationBenefitAmt"
                                    id="lastWeekParticipationBenefitAmt"
                                    formControlName="lastWeekParticipationBenefitAmt"
                                    validate-on="blur"
                                    required
                                    data-testid="editstrike-form-lastweekparticipationbnftamt" />
                                <div class="input-group-addon">.00</div>
                            </div>
                            <div *ngIf="
                  lastWeekParticipationBenefitAmt?.invalid &&
                  (lastWeekParticipationBenefitAmt?.dirty ||
                    lastWeekParticipationBenefitAmt?.touched)
                " class="alert alert-danger">
                                <div *ngIf="lastWeekParticipationBenefitAmt?.errors?.['required']">
                                    Last Week Participation Benefit Amount is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-6 col-sm-4">
                            <label for="lastWeekHelperBenefitAmt" class="control-label">Last Week Helper Benefit Amount</label>
                            <div class="input-group">
                                <div class="input-group-addon">$</div>
                                <input
                                    class="form-control"
                                    type="text"
                                    name="lastWeekHelperBenefitAmt"
                                    id="lastWeekHelperBenefitAmt"
                                    formControlName="lastWeekHelperBenefitAmt"
                                    validate-on="blur"
                                    required
                                    required-message="'Last Week Helper Benefit Amount is required'"
                                    data-testid="editstrike-form-lastweekhelperbnftamt" />
                                <div class="input-group-addon">.00</div>
                            </div>
                            <div *ngIf="
                  lastWeekHelperBenefitAmt?.invalid &&
                  (lastWeekHelperBenefitAmt?.dirty ||
                    lastWeekHelperBenefitAmt?.touched)
                " class="alert alert-danger">
                                <div *ngIf="lastWeekHelperBenefitAmt?.errors?.['required']">
                                    Last Week Helper Benefit Amount is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="comments" class="control-label">Comments</label>
                    <textarea
                        class="form-control"
                        name="comments"
                        id="comments"
                        formControlName="comments"
                        rows="3"
                        validate-on="blur"
                        required
                        data-testid="editstrike-form-comments"></textarea>
                    <div *ngIf="comments?.invalid && (comments?.dirty || comments?.touched)" class="alert alert-danger">
                        <div *ngIf="comments?.errors?.['required']" data-testid="strike-edit-comments-error">
                            Comments are required.
                        </div>
                    </div>
                </div>
                <br />
                <div class="form-group col-xs-4">
                    <div class="">
                        <input type="submit" class="btn btn-primary" value="Submit strike"
                            [disabled]="!strikeEditForm.valid || disableButton" (click)="submitStrike()"
                            data-testid="editstrike-form-button" />
                        <a class="btn btn-default" routerLink="/strikes" data-testid="edit-strike-cancel-button">Cancel</a>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <hr />
</div>
